// src/services/LoggingService.js
// Admin activity logger — writes to BigQuery via backend API.
// Replaces direct Firestore writes to 'adminLogs' collection.
import { logAdminAction } from './BigQueryService';

class LoggingService {
  constructor() {
    this.initialized = false;
  }

  initialize(db) {
    // db parameter kept for backward compatibility but no longer used.
    // BigQueryService uses Firebase Auth token instead.
    this.initialized = true;
  }

  async logActivity(adminEmail, action, details) {
    if (!this.initialized) {
      console.error('LoggingService not initialized');
      return;
    }

    try {
      await logAdminAction(action, details);
      console.log('Activity logged to BigQuery successfully');
    } catch (error) {
      console.error('Failed to log activity to BigQuery:', error);
    }
  }
}

// Singleton instance
const loggingService = new LoggingService();
export default loggingService;
